import { Request } from '../base/Request';
import { Method } from 'axios';

type MediaclipInitializeProjectData = {
  mediaclip_product_id: string;
  product_sku: string;
  mediaclip_theme_url: string;
  mediaclip_library_package: string;
  mediaclip_user_text: string;
};
export default class MediaclipInitializeProjectRequest extends Request<
  { mediaclip_product_id: string; project_id: string },
  MediaclipInitializeProjectData
> {
  // see app/code/Elgentos/ProductConfigurator/view/frontend/templates/configurator/simple/container.phtml:541
  protected getEndPoint(): string {
    return window.mediaclip_config.initSimpleProject;
  }

  protected getMethod(): Method {
    return 'GET';
  }

  public setMediaclipProductId(mediaclipProductId: string): this {
    this.data.mediaclip_product_id = mediaclipProductId;
    return this;
  }

  public setProductSku(productSku: string): this {
    this.data.product_sku = productSku;
    return this;
  }

  public setMediaclipThemeUrl(mediaclipThemeUrl: string): this {
    this.data.mediaclip_theme_url = mediaclipThemeUrl;
    return this;
  }

  public setMediaclipLibraryPackage(mediaclipLibraryPackage: string): this {
    this.data.mediaclip_library_package = mediaclipLibraryPackage;
    return this;
  }

  public setMediaclipUserText(mediaclipUserText: string): this {
    this.data.mediaclip_user_text = mediaclipUserText;
    return this;
  }
}
